<template lang="pug">
#bloco-psa-ativos-ambientais
    .blocos-psa-estrutura
        .blocos-psa-estrutura-esquerdo
            h2 PSA e ativos ambientais
            el-card.box-card
                .psa-estrutura-blocos
                    .psa-estrutura-blocos-esquerdo
                        .margin-bloco
                            h3 Fitofisionomia
                            span Floresta Ombrófila Densa

                        .margin-bloco
                            h3 Área de floresta
                            span 1.272,51ha

                        .margin-bloco
                            h3 Excedente de VN
                            span 243,92 ha

                        div
                            h3 Déficit de VN
                            span -

                    .psa-estrutura-blocos-direito
                        .margin-bloco
                            h3 Potencial de estoque de carbono
                            span 158.160,27 tC

                        div
                            h3 Número de nascentes
                            span 0

        .blocos-psa-estrutura-direito
            h2 Estrutura fundiária
            el-card.box-card
                .psa-estrutura-blocos
                    .psa-estrutura-blocos-esquerdo
                        .margin-bloco
                            h3 Risco
                            span Baixo

                        .margin-bloco
                            h3 Área do imóvel
                            span 1.288,31 ha

                        .margin-bloco
                            h3 Módulos fiscais
                            span 12,86

                        div
                            h3 Situação do CAR
                            span AT - Em análise

                    .psa-estrutura-blocos-direito
                        .margin-bloco
                            h3 Sigef identificado
                            span Sim

                        .margin-bloco
                            h3 Sobreposição com outros imóveis
                            span -

                        div
                            h3 Sobreposição com terras públicas
                            span -
</template>

<script>
export default {
    name: 'BlocoPSAeAtivosAmbientais',
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
#bloco-psa-ativos-ambientais {
    .blocos-psa-estrutura {
        display: flex;
        gap: 10px;
        justify-content: space-between;
        h2 {
            font-weight: 600;
            margin-top: 30px;
            margin-bottom: 12px;
            color: #3b3b3b;
            font-size: 16px;
        }
        .blocos-psa-estrutura-esquerdo,
        .blocos-psa-estrutura-direito,
        .psa-estrutura-blocos-direito,
        .psa-estrutura-blocos-direito {
            width: 50%;
        }
        .psa-estrutura-blocos {
            display: flex;
            gap: 10px;
            justify-content: space-between;

            h3 {
                font-size: 14px;
                color: #3b3b3b;
                font-weight: 400;
                margin-bottom: 4px;
            }
            span {
                font-size: 14px;
                color: var(--primary);
                font-weight: 600;
            }
        }
        .el-card__body {
            min-height: 278px;
        }
    }
    .margin-bloco {
        margin-bottom: 18px;
    }
}
</style>
